import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import ModularConferenceForm from './ModularConferenceForm'
import ConferenceListing from 'views/admin/conference/ConferenceListing'
import ConferenceForm from 'views/admin/conference/ConferenceForm'

const Conference = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <ConferenceListing />
      </Route>
      <Route exact path={`${path}/new`}>
        <ConferenceForm />
      </Route>
      <Route exact path={`${path}/edit/:conferenceId`}>
        <ModularConferenceForm />
      </Route>
    </Switch>
  )
}

export default Conference
